// extracted by mini-css-extract-plugin
export default {"item-list":"DessertsDesktop_item-list__-Udsd","item":"DessertsDesktop_item__EXNTb","category-title":"DessertsDesktop_category-title__TrjUR"};